import { useCallback, useEffect, useState } from "react"

import getDisplayCondition from "../../../service/getDisplayCondition"
import type EstimateValues from "../../../types/params"

const getIsInitialized = (values: EstimateValues) => {
  // 外形寸法が入力されていない
  if (values.sizeX === null && values.sizeY === null) return false

  if (values.serviceD) {
    // ピン数が入力されていない
    if (values.pinCnt === null) return false
    // 設計リクエストがすべて選択されていない
    if (
      !values.controlWiring ||
      !values.designInstruction ||
      !values.circuit ||
      !values.planBgacsp ||
      !values.externalsSilk ||
      !values.otherSilk
    ) {
      return false
    }
  }

  // 製造が選択されていて、製造枚数が入力されていない
  if (values.serviceM && values.cnt === null) return false

  if (values.serviceG) {
    const SMD = values.pieceCnt ?? 0
    const BGA = values.bgacsp ?? 0
    const DIP = values.dipPartCnt ?? 0

    if (values.sheetCnt === null) return false

    // 表面実装部品、本体下に端子が隠れている部品、挿入部品いずれも入力されていない場合
    if (values.pieceCnt === null && values.bgacsp === null && values.dipPartCnt === null) return false

    // 表面実装部品、本体下に端子が隠れている部品が入力されていて、実装面が選択されていない
    if ((SMD > 0 || BGA > 0) && !values.sideOfSmd) return false

    // 挿入部品が入力されていて、実装面が選択されていない
    if (DIP > 0 && !values.sideOfDip) return false

    const isDisplayed = getDisplayCondition(values)

    // マウントデータの支給が表示されていて、未選択の場合
    if (isDisplayed.provisionOfMountData && !values.provisionOfMountData) return false

    // メタルマスクの製造・支給選択が表示されていて、未選択の場合
    if (isDisplayed.metalMaskDtl && !values.metalMaskDtl) return false
  }

  return true
}

const useInitialize = (values: EstimateValues) => {
  const initialState = getIsInitialized(values)
  const [isInitialized, setIsInitialized] = useState(initialState)
  const initialize = useCallback(() => setIsInitialized(true), [])

  useEffect(() => {
    if (isInitialized) return

    const bool = getIsInitialized(values)
    if (bool) {
      setIsInitialized(true)
    }
  }, [isInitialized, values])

  return { isInitialized, initialize }
}

export default useInitialize
